export var FileData_PDFSettings_ViewMode;
(function (FileData_PDFSettings_ViewMode) {
    /** NONE - No PDF view */
    FileData_PDFSettings_ViewMode["NONE"] = "NONE";
    /** FULL - Full PDF view */
    FileData_PDFSettings_ViewMode["FULL"] = "FULL";
    /** MINI - Mini PDF view */
    FileData_PDFSettings_ViewMode["MINI"] = "MINI";
    FileData_PDFSettings_ViewMode["UNRECOGNIZED"] = "UNRECOGNIZED";
})(FileData_PDFSettings_ViewMode || (FileData_PDFSettings_ViewMode = {}));
//# sourceMappingURL=plugin_file.enums.js.map